<template>
  <div>
  </div>
</template>
<script>
export default {
  name: 'HealthPage',
  async created() {
    let apiUp = await this.$store.dispatch('apiStatus')
    if (apiUp === true) {
      document.documentElement.innerHTML = '<HTML><HEAD><TITLE>Server Health Checking</TITLE></HEAD><BODY><P>WEB OK</P><P>API OK</P></BODY></HTML>'
      return
    }
    document.documentElement.innerHTML = '<HTML><HEAD><TITLE>Server Health Checking</TITLE></HEAD><BODY><P>WEB OK</P><P>API DOWN</P></BODY></HTML>'
  }
}
</script>
